import { Channel } from '../../models/channel.model';


export enum ChannelActionType {
    INIT_CHANNEL = '(INITIAL) SET_CHANNEL',
    SET_CHANNEL = '(SETTER) SET_CHANNEL',
    SET_ELECTRONIC_CHANNEL = '(SETTER) SET_ELECTRONIC_CHANNEL',
    SET_CHANNEL_IDENTITY = '(SETTER) SET_CHANNEL_IDENTITY',
    SET_APPICATION_CHANNEL_REF = '(SETTER) SET_APPICATION_CHANNEL_REF'
}


export class ChannelState {
    private payload: Channel;

    constructor(payload: Channel) {
        this.payload = payload;
    }

    setElectronicChannel(electronicChannel: number): void {
        this.payload.electronic_channel = electronicChannel;
    }

    setChannalIdentity(channelIdentity: string): void {
        this.payload.channel_identity = channelIdentity;
    }

    setApplicationChannelReference(applicationChannel: string): void {
        this.payload.application_channel_reference = applicationChannel;
    }

    getValue(): Channel {
        return this.payload
    }
}

export class InitialChannelAction {
    readonly type: string = ChannelActionType.INIT_CHANNEL;
    payload: Channel;
    constructor() {
        this.payload = null;
    }
}

export class SetChannelAction {
    readonly type: string = ChannelActionType.SET_CHANNEL;
    payload: Channel;

    constructor(payload: Channel) {
        this.payload = payload;
    }
}

export class SetChannelIdentityAction {
    readonly type: string = ChannelActionType.SET_CHANNEL_IDENTITY;
    payload: Channel;

    constructor(payload: Channel) {
        this.payload = payload;
    }
}

export class SetApplicationChannelReferenceAction {
    readonly type: string = ChannelActionType.SET_APPICATION_CHANNEL_REF;
    payload: Channel;

    constructor(payload: Channel) {
        this.payload = payload;
    }
}


export class SetElectronicChannelAction {
    readonly type: string = ChannelActionType.SET_ELECTRONIC_CHANNEL;
    payload: Channel;

    constructor(payload: Channel) {
        this.payload = payload;
    }
}


export type ChannelAction = InitialChannelAction | SetChannelAction | SetChannelIdentityAction | SetApplicationChannelReferenceAction | SetElectronicChannelAction